// Shown after the recipient picks Cash App, before they enter anything (NPSD-2355): Cash App only
// pays out to an account with an active Cash App Card. Shared by the legacy and refreshed claim
// pages so the copy can't drift. Proposed wording — Jared approves the final text before release.
export const CASH_APP_CARD_NOTICE =
  "To receive money in Cash App, you need an active Cash App Card. If you don't have one, choose another way to receive.";
